import { MarkdownRenderer } from "../../../markdown-renderer";

type MessageStepMarkdownProps = {
  className: string;
  id: string | undefined;
  text: string;
};

export const MessageStepMarkdown = ({ className, id, text }: MessageStepMarkdownProps) => {
  return (
    <div className={className} id={id}>
      <MarkdownRenderer text={text} />
    </div>
  );
};
